import { callPromiseSafely } from "../../util/callPromiseSafely";
import type { TareAccountStatus } from "../types/TareBridge";
import { getTareBridge } from "./getTareBridge";

/**
 * Load account status from the native module.
 */
export async function getAccountStatus(): Promise<TareAccountStatus | null> {
  return callPromiseSafely(getTareBridge()?.getAccountStatus);
}

export function getAccountStatusSync(): TareAccountStatus | null {
  return getTareBridge()?.getAccountStatusSync?.() ?? null;
}
